<template>
  <collapsable
    :collapsed="collapsed"
    :title="$t('entities.checkup_measurement_groups.title', {name: entity.name})"
  >
    <div v-if="isFetchingServer">
      <LoadingAnimation class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
    </div>
    <div v-else>
      <div class="row evollu-form mt-3" v-if="measurementTypesInfo.length > 0">
          <div class="col-12">
            <div>
              <multiselect
                v-model="vmodelMeasurementGroups"
                :options="measurementTypesInfo"
                track-by="id"
                :customLabel="val => $t(`dashboard_new_evollu.parameters.${addUnderscoreToUppercase(val.slug)}`, val.slug)"
                select-label=""
                selected-label=""
                deselect-label=""
                :placeholder="$t('entities.checkup_measurement_groups.title', {name: entity.name})"
                :allow-empty="true"
                :multiple="true"
                :close-on-select="false"
                :searchable="true">
                <template slot="clear">
                <span class="multiselect__clear" v-if="vmodelMeasurementGroups.length > 0"
                      @mousedown.prevent.stop="vmodelMeasurementGroups = []"></span>
                </template>
              </multiselect>
            </div>
        </div>

        <div class="row col-12 d-flex justify-content-end mt-3" v-if="changesDetected">
          <va-button @click.prevent="update">
            {{ $t('agenda.availability.save') }}
          </va-button>
        </div>
      </div>
      <div v-else class="row col-12 text-center">
        <span class="is-bold" style="font-size: 20px">{{ $t('clinical.people.no_data') }}</span>
      </div>
    </div>

    <div v-show="showLoadingIndicator">
      <LoadingAnimation :size="'5px'" class="d-flex justify-content-center pt-4 pb-4"></LoadingAnimation>
    </div>
  </collapsable>
</template>

<script>
import LoadingAnimation from '@/components/common/LoadingAnimation.vue';
import Collapsable from '@/components/common/Collapsable.vue';
import { AuthEvohealthService, EntityService } from '@/api/AuthService';
import { EvohealthService } from '@/api/EvohealthService';
import Multiselect from 'vue-multiselect';
import { mapState } from 'vuex';

export default {
  components: { Multiselect, Collapsable, LoadingAnimation },
  props: {
    entity: {
      type: Object,
      required: true
    },
    collapsed: {
      type: Boolean,
      required: false
    },
    limitItems: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      isFetchingServer: false,
      showLoadingIndicator: false,
      permitableHealthGroups: [],
      completeHealthGroups: [],
      vmodelMeasurementGroups: [],
      entityMeasurementGroups: [],
    }
  },
  async created() {
    await this.setLoadingState(true)
    try {
      this.entityMeasurementGroups = await EntityService.getCheckupEntityMeasurementGroups(this.entity.id);
      const groupIdsSet = new Set(this.entityMeasurementGroups.map(e => e.checkup_measurement_group_id));
      this.vmodelMeasurementGroups = this.measurementTypesInfo.filter(meas =>
        groupIdsSet.has(meas.measurementGroupId)
      );
    } catch(err) {
      await this.handleError(err)
    } finally {
      await this.setLoadingState(false)
    }

  },
  methods: {
    addUnderscoreToUppercase: function (inputString) {
      var modifiedString = "";

      for (var i = 0; i < inputString.length; i++) {
        var currentChar = inputString.charAt(i);

        if (currentChar === currentChar.toUpperCase() && /[A-Z]/.test(currentChar)) {
          // If the character is uppercase, add an underscore and the lowercase version
          modifiedString += "_" + currentChar.toLowerCase();
        } else {
          // If the character is not uppercase, keep it as is
          modifiedString += currentChar;
        }
      }

      return modifiedString;
    },
    setLoadingState: async function(loading) {
      if (loading) {
        this.isFetchingServer = true;
      } else {
        setTimeout(() => {
          this.isFetchingServer = false
        }, 300)
      }
    },
    handleError: async function(error) {
      console.error('Operation failed:', error);
      this.showToast(
        this.$t('roles.something_went_wrong'),
        this.$store.state.errorToastOptions
      );
    },
    update: async function() {
      await this.setLoadingState(true);
      try {
        const updatedGroupsIds = this.vmodelMeasurementGroups.map(elem => parseInt(elem.measurementGroupId));
        this.entityMeasurementGroups = await EntityService.updateEntityCheckupMeasurementGroups(
          this.entity.id,
          updatedGroupsIds
        );
      } catch (error) {
        await this.handleError(error);
      } finally {
        await this.setLoadingState(false);
      }
    }
  },
  computed: {
    changesDetected: function() {
      if ((this.entityMeasurementGroups.length === 0 && this.vmodelMeasurementGroups.length === 0) || this.vmodelMeasurementGroups.length === 0) {
        return false;
      }
      const originalIds = new Set(this.entityMeasurementGroups.map(group => group.checkup_measurement_group_id));
      const currentIds = new Set(this.vmodelMeasurementGroups.map(group => group.measurementGroupId));

      return [...originalIds].some(id => !currentIds.has(id)) || [...currentIds].some(id => !originalIds.has(id));
    },
    ...mapState({
      measurementTypesInfo (state, getters) {
        return getters[`checkup/measurementTypesInfo`] || []
      }
    }),
  },
};
</script>

<style scoped lang="scss">

</style>
